import {useState} from "react";
import {Box,ImageListItem,ImageListItemBar,IconButton,Tooltip} from '@mui/material';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import NOIMAGE_DEFAULT from "../../assets/no-image.png";

const ImageItem=({img,index,noImage,application,handleDeleteImage,openPreviewPopup})=>{
    const [loaded,setLoaded]=useState(false);
    const fallback=noImage??NOIMAGE_DEFAULT;

    return (
        <Box
            sx={{
                width:{xs:90,sm:100,md:120},
                height:{xs:90,sm:100,md:120},
                border:"1px solid #ccc",
                borderRadius:1,
                overflow:"hidden",
                cursor:"pointer",
                position:"relative"}}>
            <ImageListItem
                key={img.id}
                onClick={()=>openPreviewPopup(img,index)}
                sx={{cursor:"pointer",position:"relative"}}>
                {!loaded&&(
                <img
                    src={fallback}
                    alt={application.getLocale("TitleImage")}
                    style={{
                        position:"absolute",
                        width:"100%",
                        height:"100%",
                        objectFit:"cover"}}/>
                )}
                <img
                    src={img.thumb_data||fallback}
                    alt={img.filename}
                    onLoad={()=>setLoaded(true)}
                    onError={(e)=>{
                        e.target.onerror=null;
                        e.target.src=fallback;
                    }}
                    style={{
                        width:"100%",
                        height:"100%",
                        objectFit:"cover",
                        opacity:loaded?1:0,
                        transition:"opacity 0.2s ease"
                    }}/>
                <ImageListItemBar
                    sx={{
                        height:28,
                        background:"linear-gradient(to top, rgba(0,0,0,0.7), rgba(0,0,0,0.1))",
                        '.MuiImageListItemBar-titleWrap':{
                            display:'none'
                        }
                    }}
                    actionIcon={
                        <Tooltip 
                            placement="top"
                            title={application.getLocale("ButtonDelete")}>
                            <IconButton
                                onClick={(e)=>{
                                    e.stopPropagation();
                                    handleDeleteImage(img);
                                }}
                                sx={{
                                    color:"white",
                                    bgcolor:"rgba(255,0,0,0.3)",
                                    '&:hover':{
                                        bgcolor:"rgba(255,0,0,1)"
                                    },
                                    mr:0.5,
                                    p:0.5}}>
                                <HighlightOffOutlinedIcon fontSize="small"/>
                            </IconButton>
                        </Tooltip>
                    }
                />
            </ImageListItem>
        </Box>
    );
};

export default ImageItem;